import { LOG_TYPE, addLog } from '@Service/loggingService';

const GetReducerThatChanged = (beforeStates, afterStates) => {
    const len = Object.keys(beforeStates).length;
    for (let i = 0; i < len; i += 1) {
        const strBeforeReducer = JSON.stringify(Object.values(beforeStates)[i]);
        const strAfterReducer = JSON.stringify(Object.values(afterStates)[i]);
        if (strBeforeReducer !== strAfterReducer) {
            return i;
        }
    }

    return -1;
};

const LogAndCrashReporter = store => next => action => {
    const verboseLogging = false;
    if (verboseLogging) {
        try {
            const logMessageMaxSize = 8000; // ~8K
            const beforeStateAllReducers = store.getState();
            const retValue = next(action);
            const afterStateAllReducers = store.getState();

            const reducerThatChangedIndx = GetReducerThatChanged(
                beforeStateAllReducers,
                afterStateAllReducers
            );

            let payLoad = JSON.stringify(action).replace(new RegExp('\\"', 'g'), "'");
            if (payLoad.length > logMessageMaxSize) {
                payLoad = `${payLoad.substring(0, logMessageMaxSize)} ...`;
            }

            if (reducerThatChangedIndx > -1) {
                const keyName = Object.keys(beforeStateAllReducers)[reducerThatChangedIndx];
                const beforeReducrState = JSON.parse(
                    JSON.stringify(Object.values(beforeStateAllReducers)[reducerThatChangedIndx])
                );
                const afterReducrState = JSON.parse(
                    JSON.stringify(Object.values(afterStateAllReducers)[reducerThatChangedIndx])
                );

                // anonymize metadata in trace
                if (keyName === 'document') {
                    beforeReducrState.metadata = [];
                    afterReducrState.metadata = [];
                    beforeReducrState.userViews = [];
                    afterReducrState.userViews = [];
                }

                if (keyName === 'authenticationReducer') {
                    beforeReducrState.activeSystem = '#anonymized#';
                    afterReducrState.activeSystem = '#anonymized#';

                    beforeReducrState.sealSystems = {};
                    afterReducrState.sealSystems = {};

                    beforeReducrState.user = {};
                    afterReducrState.user = {};
                }

                if (keyName === 'clauseReducer') {
                    beforeReducrState.clausedata = [];
                    afterReducrState.clausedata = [];
                }

                if (keyName === 'scoreCardReducer') {
                    if (
                        beforeReducrState &&
                        beforeReducrState.scorecard &&
                        beforeReducrState.scorecard.data &&
                        beforeReducrState.scorecard.data.scoreCardElementList
                    ) {
                        // anonymize scorecard data in trace
                        beforeReducrState.scorecard.data.scoreCardElementList = [];
                    }

                    if (
                        afterReducrState &&
                        afterReducrState.scorecard &&
                        afterReducrState.scorecard.data &&
                        afterReducrState.scorecard.data.scoreCardElementList
                    ) {
                        // anonymize scorecard data in trace
                        afterReducrState.scorecard.data.scoreCardElementList = [];
                    }
                }

                let beforeReducerState = `${keyName}: ${JSON.stringify(beforeReducrState)}`;
                let afterReducerState = `${keyName}: ${JSON.stringify(afterReducrState)}`;

                beforeReducerState = beforeReducerState.replace(new RegExp('\\"', 'g'), "'");
                afterReducerState = afterReducerState.replace(new RegExp('\\"', 'g'), "'");

                if (beforeReducerState.startsWith('auth:')) beforeReducerState = '#anonymized#';
                if (afterReducerState.startsWith('auth:')) afterReducerState = '#anonymized#';
                beforeReducerState = `Before State: ${beforeReducerState}`;
                afterReducerState = `After  State: ${afterReducerState}`;

                addLog(LOG_TYPE.INFO, 'reducer', beforeReducerState);
                addLog(LOG_TYPE.ACTION, 'reducer', payLoad);
                addLog(LOG_TYPE.INFO, 'reducer', afterReducerState);
            } else {
                addLog(LOG_TYPE.INFO, 'reducer', 'No state change');
                addLog(LOG_TYPE.ACTION, 'reducer', payLoad);
                addLog(LOG_TYPE.INFO, 'reducer', 'No state change');
            }

            return retValue;
        } catch (err) {
            addLog(LOG_TYPE.ERROR, 'reducer', err);
        }
    }
    return next(action);
};

export default LogAndCrashReporter;
